export const WINDOWS = ["morning", "afternoon", "evening"];
export const emptyRecipient = { name: "", phone: "", phone_country: "MA", whatsapp: "", whatsapp_country: "", address_line1: "", apartment: "", address_line2: "", address: "", landmark: "", call_before_delivery: true };
export const validPhone = (p) => /^\+?212[5-8]\d{8}$/.test((p || "").replace(/[\s-]/g, ""));
// Phone fields hold just the local part; the picked country's dial code is prefixed at submit time.
export const withDial = (local, dial = "+212") => {
  let s = (local || "").replace(/[\s-]/g, "");
  if (s.startsWith("00")) s = `+${s.slice(2)}`;
  if (s.startsWith(dial)) s = s.slice(dial.length);
  const digits = s.replace(/\D/g, "").replace(/^0+/, "");
  return digits ? `${dial}${digits}` : "";
};
export const stripDial = (full) => (full || "").replace(/^\+?212\s*/, "").replace(/^0+/, "");
// Moroccan numbers keep the strict mobile check; foreign ones need 6+ digits and ≤15 in E.164.
export const validLocal = (local, dial = "+212") => {
  if (dial === "+212") return validPhone(withDial(local));
  const digits = (local || "").replace(/[\s-]/g, "").replace(/^0+/, "");
  return /^\d{6,}$/.test(digits) && digits.length + dial.replace(/\D/g, "").length <= 15;
};
// Split a full international number into {country, phone-local} by the longest known dial prefix.
export const parseBuyerPhone = (full, list) => {
  const raw = (full || "").replace(/[^\d+]/g, "");
  if (!raw) return null;
  const withPlus = raw.startsWith("+") ? raw : `+${raw}`;
  const match = (list || [])
    .filter((c) => c.dial && withPlus.startsWith(c.dial))
    .sort((a, b) => b.dial.length - a.dial.length)[0];
  if (match) return { country: match.code, phone: withPlus.slice(match.dial.length).replace(/^0+/, "") };
  return { country: null, phone: raw.replace(/^\+/, "").replace(/^0+/, "") };
};
// Saved / resumed recipient numbers may be "+<dial><local>" or a bare local part.
export const splitRecipientPhone = (full, list) => {
  const raw = (full || "").trim();
  if (!raw) return { country: "MA", local: "" };
  const norm = raw.startsWith("00") ? `+${raw.slice(2)}` : raw;
  if (!norm.startsWith("+")) return { country: "MA", local: stripDial(norm) };
  const parsed = parseBuyerPhone(norm, list);
  if (parsed?.country) return { country: parsed.country, local: parsed.phone };
  return { country: "MA", local: stripDial(norm) };
};
// The backend stores one address string; keep the structured inputs separated by " · ".
export const joinAddress = (r) => {
  const parts = [r.address_line1, r.apartment, r.address_line2].map((s) => (s || "").trim()).filter(Boolean);
  return parts.length ? parts.join(" · ") : (r.address || "");
};
export const CONSENT_TXT = {
  en: ["I have read and agree to the", "and the"],
  fr: ["J'ai lu et j'accepte les", "et la"],
  es: ["He leído y acepto los", "y la"],
  ar: ["لقد قرأت وأوافق على", "و"],
  it: ["Ho letto e accetto i", "e i"],
  nl: ["Ik heb gelezen en ga akkoord met de", "en de"],
  de: ["Ich habe gelesen und stimme den", "und den"],
};
export const ANSWER_REQUIRED = {
  en: "Please select an answer to continue.",
  fr: "Veuillez choisir une réponse pour continuer.",
  es: "Seleccione una respuesta para continuar.",
  ar: "يرجى اختيار إجابة للمتابعة.",
  it: "Seleziona una risposta per continuare.",
  nl: "Selecteer een antwoord om door te gaan.",
  de: "Bitte wählen Sie eine Antwort aus, um fortzufahren.",
};
export const today = () => new Date().toISOString().slice(0, 10);
export const tomorrow = () => { const d = new Date(); d.setDate(d.getDate() + 1); return d.toISOString().slice(0, 10); };
